<nav class="nav nav-pills flex-column" id="admin-menu">
  @for (item of navItems; track item) {
    <a
      class="nav-item nav-link"
      id="{{item.id}}-tab-menu"
      [class.active]="currentTab == item.id"
      [class.nav-link-child]="item.isChild"
      [routerLink]="['/admin/' + item.id]">
      {{item.title}}
    </a>
  }
</nav>
